import { useState, useRef, useEffect } from 'react';
import logo from '../assets/icons/Group 35098.svg';
import schoolLogo from '../assets/icons/icons8-school.svg';
import { useNavigate } from 'react-router-dom';
import { clearSession } from '../store/slices/sessionSlice';
import { useDispatch } from 'react-redux';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import { clearAngularSession } from '../shared/services/sessionBridge';
import './layout.scss';
const Header = () => {
  const s = useSelector((state: RootState) => state.session);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    setDropdownOpen(false);

    // 1. Clear React side
    dispatch(clearSession());

    // 2. Clear the Angular EMIS session over the cross-origin bridge.
    //    Fire-and-forget: navigate to login regardless of ack/timeout.
    clearAngularSession().finally(() => {
      navigate('/');
    });
  };

  const handleResetPassword = () => {
    setDropdownOpen(false);
    navigate('/reset-password');
  };

  return (
    <header className="app-header d-flex align-items-center justify-content-between px-3">
      {/* Logo Area */}
      <div className="logo-area d-flex align-items-center">
        <img src={logo} alt="Logo" height={50} />
      </div>

      {/* Right Area */}
      <div className="header-right d-flex align-items-center gap-3">
        <img src={schoolLogo} alt="Logo" height={25} />
        <div className="d-block">
          <div>
            <span>
              <b>{s.schoolName}</b>
            </span>
          </div>
          <div>
            <span>{s.username}</span>
          </div>
        </div>

        {/* Dropdown Toggle */}
        <div className="header-dropdown" ref={dropdownRef}>
          <button
            className="header-dropdown-toggle"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            aria-label="User menu"
          >
            <i
              className={`pi ${dropdownOpen ? 'pi-chevron-up' : 'pi-chevron-down'}`}
            />
          </button>

          {dropdownOpen && (
            <div className="header-dropdown-menu">
              <button
                className="header-dropdown-item"
                onClick={handleResetPassword}
              >
                <i className="pi pi-key" />
                <span>Reset Password</span>
              </button>
              <button className="header-dropdown-item" onClick={handleLogout}>
                <i className="pi pi-sign-out" />
                <span>Log Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
